import { props } from '@ngrx/store';
import { Student, StudentCreateValue, StudentUpdateValue } from '../models';

import { createActionGroup, emptyProps } from '@ngrx/store';

export const studentActions = createActionGroup({
    source: 'Admin Student',
    events: {
        'Get Student': props<{ id: string }>(),
        'Get Student Success': props<{ payload: Student }>(),
        'Get Student Error': props<{ id: string }>(),

        'Add Student': props<{ value: StudentCreateValue }>(),
        'Add Student Success': emptyProps(),
        'Add Student Error': emptyProps(),

        'Update Student': props<{ id: string; value: StudentUpdateValue }>(),
        'Update Student Success': emptyProps(),
        'Update Student Error': emptyProps(),

        'Delete Student': props<{ id: string }>(),
        'Delete Student Success': emptyProps(),
        'Delete Student Error': emptyProps(),

        Clear: emptyProps(),
    },
});
